module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow-em_primary-6c15aa7ac07524bb36dc6df7ba11d32e.svg";